/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


$(document).ready( function(){
  if($(".with-sidebar").length){
    $("body").addClass("lightgray-bg");
  }
  else if($(".health-pro-main").length){
    $("body").addClass("lightgray-bg-main");
  }
  else if($(".sm-login-box").length){
    $("body").addClass("lightgray-bg");
  }


  // TABS caption
  $(document).on('click','a[data-role="tabs"]', function(){
    var target = $(this).data('target');
    if(!$(this).parent("li").hasClass("active")){
      $(".tabs-linking li").removeClass("active");
      $(".tabcap-area .tabs-block").stop().slideUp().removeClass("show");
      $(this).parent("li").addClass("active");
      $(target).stop().slideDown().addClass("show");


      if ($(window).width() <= 1023){
        var target = $(this).data('target');
        var scrollToPosition = $(".tabcap-area").offset().top;
        $('html, body').stop().animate({ 
          scrollTop: scrollToPosition
        }, 600, function() {
          location.hash = target;  
        });
      }

    }

  })

  if(!$(".recipe_menu li").hasClass("active")){
    var urltype = window.location.href.split("=");  
    $('.recipe_menu li').each(function(){
      var thissi = $(this).data('link');
      if(urltype[1].indexOf(thissi) != -1){
        $(this).addClass("active")
      }
    });
  }

  $(document).on("click", ".FaqSummary a.FaqSummary__Link", function(){
    $(".Faq h1.Faq__Section").removeClass("active");
    $($(this).attr("href")).parent("h1").addClass("active");
  }) 

})

$(window).load(function(){
  $(".mCustomScrollbar").mCustomScrollbar({
    scrollButtons:{enable:true},
    theme:"light-1",
    scrollbarPosition:"outside",
    autoHideScrollbar: true
  });

  $("#sidebar-menu .sidebar-menu-overflow").mCustomScrollbar({
    scrollButtons:{enable:true},
    scrollbarPosition:"nideside",

  });



  // Restricts input for the given textbox to the given inputFilter.
  function setInputFilter(textbox, inputFilter) {
    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
      if(textbox){
        textbox.addEventListener(event, function() {
          if (inputFilter(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
          } else if (this.hasOwnProperty("oldValue")) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
          }
        });
      }
    });
  }


  // Install input filters.
  // setInputFilter(document.getElementById("quantity"), function(value) {
  //   return /^-?\d*$/.test(value); });

  setInputFilter(document.getElementById("quantity"), function(value) {
    return /^\d*$/.test(value) && (value === "" || parseInt(value) <= 9999); });

  //   setInputFilter(document.getElementsByClassName("QuantitySelector__CurrentQuantity"), function(value) {
  //   return /^\d*$/.test(value) && (value === "" || parseInt(value) <= 9999); });

  //   var el = document.getElementById('cartquantity');
  //   if(el){
  //     el.addEventListener('click', function setInputFilter (value) {
  //      return /^\d*$/.test(value) && (value === "" || parseInt(value) <= 9999); });
  //   }


  // setInputFilter(document.getElementById("uintTextBox"), function(value) {
  //   return /^\d*$/.test(value); });
  // setInputFilter(document.getElementById("hexTextBox"), function(value) {
  //   return /^[0-9a-f]*$/i.test(value); });
  // setInputFilter(document.getElementById("floatTextBox"), function(value) {
  //   return /^-?\d*[.,]?\d*$/.test(value); });
  // setInputFilter(document.getElementById("currencyTextBox"), function(value) {
  //   return /^-?\d*[.,]?\d{0,2}$/.test(value); });


});



// $(document).ready(function() {
//   var url = $(location).attr('href');
//   var parts = url.split("?");
//   alert(document.referrer)
//   alert(parts[1]);
// });

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
  }
}

document.querySelector('.PageTransition').remove();

var contactButton = document.querySelector('.ProductForm__AddToCart');

if(contactButton !== null) {
  var popup = document.querySelector('.product_popup_overlay');
  var closeButton = document.querySelector('.product_popup_close');

  contactButton.addEventListener('click', function(e) {
    e.preventDefault();
    popup.classList.remove('product_popup_unset');
  });
  
  closeButton.addEventListener('click', function() {
    popup.classList.add('product_popup_unset');
  });

  popup.addEventListener('click', function(e) {
    if (e.target !== this) return
    else popup.classList.add('product_popup_unset');
  });
}
